import { createAction, props } from '@ngrx/store';

export const updateParkingAddressDetails = createAction(
  '[WhereIParkMyCar] Update Overnight Parking Address Details',
  props<{ updatedParkingAddressDetails: any}>()
);

export const resetParkingAddressDetails = createAction(
  '[WhereIParkMyCar] Reset Overnight Parking Address'
);

export const resetError = createAction(
  '[WhereIParkMyCar] Reset Error'
);

export type WhereIparkMyCarActionsUnion = ReturnType<typeof updateParkingAddressDetails | typeof resetParkingAddressDetails | typeof resetError>;
